<template>

    <aside class="sidenav">


        <div class="logo" >
            <img src="@/assets/saven_potentiel_picto.png" />
        </div>

        <div id="sidebarToggle" @click="$emit('toggleNav')">
            <IconRetractSideNav />
        </div>

        <div class="userinfo" @click="goProfile">
        <!-- <div class="userinfo" > -->
            <div class="user_settings"><iconSettings /></div>
            <span class="username">{{ username }}</span>
        </div>


        <div class="main_nav">
            <ul>
                <li class="sidenav-item" v-bind:class="{active: isActiveFor(evaluationsViewNames)}">
                    <router-link :to="'/'">
                        <iconEval class="icon_eval" /> <span class="nav_label">{{ $t('layouts.user.nav.evaluations') }}</span>
                    </router-link>
                </li>
            </ul>
        </div>

        <div class="bottom_menu">
            <div class="bottom_menu_item locale_dropdown_container">
                <LocaleSwitcher v-if="localeSwitcherAccess" />
            </div>
            <div class="bottom_menu_item link_item" >
                <a target="_blank" href="https://saven.fr/aide-saven-potentiel/">
                     <iconHelp /> <span class="nav_label">{{ $t('layouts.user.nav.faq') }}</span>
                </a>
            </div>
        </div>

        <div class="toggle_app">
            <span class="logout_btn"  v-on:click="logout"><a><i class="zmdi zmdi-power"></i></a></span>
            <div  v-if="!isMiniSideBar" class="logo_saven">
                <span  v-if="!isMiniSideBar">By</span>
                <img src="@/assets/saven_logo.png" />
            </div>
            <!-- <span class="toggle_app_btn"><i class="icon-arrow-down"></i></span> -->
        </div>

    </aside>

</template>

<script>
import LogoSharp from './logoSharp'
import PictoSight from './pictoSight'
import LogoSaven from './logoSaven'
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {
    name: 'sideNav',
    props: ['isMiniSideBar'],
    components: {
        LogoSharp,
        LogoSaven,
        PictoSight
    },
    data: function(){
        return {
            username: JSON.parse(localStorage.getItem('account')).user.username,
            userRole: JSON.parse(localStorage.getItem('account')).licence.account_type,
            currentRoute: this.$route.name,
            evaluationsViewNames: ['EvaluationsIndex', 'EvaluationsNew', 'EvaluationEdit'],
        }
    },
    methods: {
        logout: function () {
            this.$store.dispatch('UserStore/logout', {})
                .then(() => this.$router.push('/login'))
                .catch(err => console.log(err))
        },
        isActiveFor(viewNames){
            return viewNames.includes(this.currentRoute)
        },
        goProfile(){
            this.$router.push('/profile')
        }
    },
    computed: {
        localeSwitcherAccess() {
            return false
            // return userCanAccess('languages', 'english')
        }
    },
    watch: {
            '$route' (to, from) {
                this.currentRoute = to.name
            }
        }
    }

</script>

<style lang="scss" >


.sidenav{
    background: $sidebar-bg-fallback;
    background: $sidebar-bg;
    display: flex;
    flex-direction: column;
    width: $sidebar-width;
    min-width: $sidebar-width;
    max-width: $sidebar-width;
    padding: 0 30px;
    position: relative;
    transition: .25s all;

    #sidebarToggle{
        position: absolute;
        left: 25px;
        top: 20px;
        cursor: pointer;
        svg{
            transform: rotate(0deg);
            width: 38px;
            height: 51px;
            fill: white;
            &:hover{
                fill: $sidebar-link-color-active;
            }

        }
    }

    .logo{
        width: 100%;
        height:150px;
        text-align: center;
        padding-top: 35px;
        overflow: hidden;
        svg{
            width: 130px;
            fill: $white;
        }
        img{
            width: 80px;
        }
    }
    .userinfo{
        height: 70px;
        border-top: 1px solid #ffffff50;
        border-bottom: 1px solid #ffffff50;
        color: #fff;
        display: flex;
        align-items: center;
        cursor: pointer;
        .user_settings{
            width: 28px;
            height: 28px;
            background-color: $info;
            border-radius: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 12px;
            svg{
                padding-top:4px;
                width: 16px;
                fill: white;
            }
        }
        &:hover{
            svg{
                animation: rotating 2s linear infinite;
            }
        }

    }
    .main_nav{
        flex: 1;
        .sidenav-item{
            a{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                cursor: pointer;
                height: 50px;
                line-height: 50px;
                color: $sidebar-link-color;
                font-weight: 400;
                transition: .2s all;
            }
            svg{
                margin-right: 12px;
                width: 18px;
                max-height: 25px;
                fill: $sidebar-link-color;
                transition: .2s all;
                &.icon_eval, &.icon_ref{
                    width: 45px;
                    height: 45px;
                    margin-right: 0px;
                    margin-left: -13px;
                }
            }
            &:hover, &.active{
                a, svg{
                    color: $sidebar-link-color-active;
                    fill: $sidebar-link-color-active;
                    font-weight: 500;
                }
            }
        }
        .retract-icon{
            svg{
                width: 38px;
                max-height: 50px;
            }
        }
    }
    .bottom_menu{
        .bottom_menu_item{
            border-top: 1px solid #ffffff50;
            &:last-child{
                border-bottom: 1px solid #ffffff50;
            }
            &.locale_dropdown_container{
                padding: 8px 0;
            }
            &.link_item{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                a{
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    color: white;
                    span{
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        height:50px;
                    }
                    svg{
                        margin-right: 12px;
                        width: 24px;
                        max-height: 25px;
                        fill: $sidebar-link-color;
                        transition: .2s all;
                    }
                }
            }
        }
    }
    .toggle_app{
        position: relative;
        padding: 20px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .logout_btn{
            font-size: 1.5rem;
            position: absolute;
            left: 0;
        }
        .logo_saven{
            // width: 80px;
            display: flex;
            font-weight: 800;
            color: white;
            vertical-align: middle;
            img{
                width: 80px;
            }
        }
        span{
            padding: 0 6px;
            text-transform: uppercase;
            &.toggle_app_btn{
                background: $sidebar-link-color;
                border-radius: 100%;
                min-height:25px;
                max-height:25px;
                min-width:25px;
                max-width:25px;
                text-align: center;
                cursor: pointer;
                padding: 0;
                line-height: 27px;
                margin-left: 12px;
                color: white;
            }
        }


    }
}
@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#layout-user.mini-sidenav{
    .sidenav{
        width: $mini-sidebar-width;
        min-width: $mini-sidebar-width;
        max-width: $mini-sidebar-width;
        padding: 0 14px;
        transition: .25s all;
        .logo{
            height:80px;
            transition: .3s all;
        }
        #sidebarToggle{
            position: static;
            // transition: .25s all;
            text-align: center;
            transform: rotate(180deg);
        }
        .main_nav{
            .sidenav-item{
                a{
                    justify-content: center;
                    position: relative;
                    &:hover{
                        .nav_label{
                            opacity: 1;
                            display: block;
                            left: 40px;
                        }
                    }
                }
                svg{
                    margin-right: 0;
                    width: 22px;
                    max-height: 28px;
                    transition: .3s all;
                    &.icon_eval, &.icon_ref{
                        width: 45px;
                        height: 45px;
                        margin-right: 0px;
                        margin-left: 0px;
                    }
                }
            }
        }
        .nav_label{
            opacity: 0;
            position: absolute;
            width: auto;
            min-width: 180px;
            transition: .3s all;
            z-index: 500;
            background: $sidebar-bg;
            left: -300px;
            padding: 0 30px;
            color: $white;

        }
        .bottom_menu{
            .bottom_menu_item{
                justify-content: center;
                position: relative;
                border: none;
                &:hover{
                    .nav_label{
                        opacity: 1;
                        display: block;
                        left: 40px;
                        height: 50px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                    }
                }
                svg{
                    margin-right: 0;
                    width: 22px;
                    max-height: 28px;
                    transition: .3s all;
                }
            }
            .locale_dropdown{
                width: 100%;
                min-width: 180px;
                .dropdown-trigger{
                    .flag_container{
                        padding-left: 6px;
                        span{
                            display: none;
                        }
                    }
                    i{
                        display: none;
                    }
                }
            }
        }

        .userinfo{
            border: none;
            height: 50px;
            justify-content: center;
            .user_settings{
                margin: 0;
            }
            .username{
                opacity: 0;
                position: absolute;
                width: auto;
                transition: .3s all;
                z-index: 500;
                background: $sidebar-bg;
                left: -300px;
                padding: 0 30px;
                color: $white;
            }
            &:hover{
                .username{
                    opacity: 1;
                    display: block;
                    left: 50px;
                }
            }
        }

    }
}

</style>